/**
 * Font weight definitions used throughout the Ardoq design system.
 *
 * @internal These tokens should only be used within the design system.
 * Use the typography components or mixins from `@ardoq/typography` instead.
 *
 * Note: Prefer to specify the line height with a unitless number, not with
 * the rem unit. You can use: calc(${lineHeight.regular} / ${fontSize.regular});
 * to get the line height as a unitless number.
 */
export const lineHeight = {
  small: '1rem', // 16px
  regular: '1.25rem', // 20px
  large: '1.375rem', // 22px
  xlarge: '1.5rem', // 24px
  x2large: '1.75rem', // 28px
};
